export default __webpack_public_path__ + "static/media/kenwood-logo.f30ab918.svg";